module.exports = "/assets/data/263dec0012839a267608f5c235ab90bc-CB10.data.json";